import React, { useEffect, useMemo, useRef } from "react";
import { FeedbackState } from "../components/FeedbackState";
import { SelfFixtureBetsScoreAndWinner } from "../components/SelfFixtureBetsScoreAndWinner";
import { useBets } from "../context/betsContext";
import { normalizePlayerBetsForView } from "../helpers/betsNormalization";

function FixtureBets() {
	const {
		infoPlayerBets,
		getInfoPlayerBets,
		dateMatchs,
		loadingPlayerBets,
		playerBetsError,
	} = useBets();

	const getInfoPlayerBetsRef = useRef(getInfoPlayerBets);

	useEffect(() => {
		getInfoPlayerBetsRef.current = getInfoPlayerBets;
	}, [getInfoPlayerBets]);

	useEffect(() => {
		getInfoPlayerBetsRef.current();
	}, []);

	const infoPlayerBetsWithDateChanged = useMemo(
		() =>
			typeof infoPlayerBets.Result === "undefined"
				? null
				: normalizePlayerBetsForView(infoPlayerBets.Result, dateMatchs),
		[dateMatchs, infoPlayerBets]
	);

	return (
		<React.Fragment>
			{loadingPlayerBets && (
				<div className='fixture-bets-skeleton' aria-hidden='true'>
					{Array.from({ length: 3 }).map((_, index) => (
						<div key={`fixture-skeleton-${index}`} className='fixture-bets-skeleton-card'>
							<div className='fixture-bets-skeleton-line fixture-bets-skeleton-line-short'></div>
							<div className='fixture-bets-skeleton-line fixture-bets-skeleton-line-medium'></div>
							<div className='fixture-bets-skeleton-row'>
								<div className='fixture-bets-skeleton-badge'></div>
								<div className='fixture-bets-skeleton-line fixture-bets-skeleton-line-full'></div>
								<div className='fixture-bets-skeleton-score'></div>
							</div>
							<div className='fixture-bets-skeleton-row'>
								<div className='fixture-bets-skeleton-badge'></div>
								<div className='fixture-bets-skeleton-line fixture-bets-skeleton-line-full'></div>
								<div className='fixture-bets-skeleton-score'></div>
							</div>
						</div>
					))}
				</div>
			)}

			{!loadingPlayerBets && playerBetsError && (
				<FeedbackState
					variant='error'
					title='No pudimos cargar tus partidos'
					description={playerBetsError}
					actionLabel='Reintentar'
					onAction={getInfoPlayerBets}
				/>
			)}

			{!loadingPlayerBets &&
				!playerBetsError &&
				infoPlayerBetsWithDateChanged?.length === 0 && (
					<FeedbackState
						variant='empty'
						title='No tienes partidos pendientes'
						description='Cuando tu grupo tenga nuevos encuentros disponibles, apareceran aqui listos para pronosticar.'
					/>
				)}

			{!loadingPlayerBets &&
				!playerBetsError &&
				infoPlayerBetsWithDateChanged?.length > 0 && (
				<SelfFixtureBetsScoreAndWinner
					infoPlayerBetsWithDateChanged={infoPlayerBetsWithDateChanged}
				/>
			)}
		</React.Fragment>
	);
}

export { FixtureBets };
